import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'
import tr from 'vuetify/lib/locale/tr'
import preset from './default-preset/preset'

Vue.use(Vuetify)

export default new Vuetify({
  preset,
  lang: { locales: { tr }, current: 'tr' },
  icons: {
    iconfont: 'mdiSvg',
  },
  theme: {
    dark: true,
    options: {
      customProperties: true,
      variations: false,
    },
  },
})
